module.exports = __webpack_public_path__ + "img/volvo_scrw.19dfc0aa.svg";